module.exports = __webpack_public_path__ + "static/media/pinIcon.26f46bcc.svg";